export interface AuthProps {
  grant_type: string;
  assertion: string;
  provider?: string;
}

export interface ILoginFormData {
  email: string;
  password: string;
}

export interface AcceptInvitationResponse {
  email: string;
}

export enum GrantTypes {
  ASSERTION = 'assertion',
  PASSWORD = 'password',
  REFRESH_TOKEN = 'refresh_token',
}

export enum Providers {
  LATANA = 'admin_internal',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
}

export enum ScreenType {
  LOGIN = 'login',
  RESET = 'reset',
}
